export const Difficulties = {
  easy: 0.1,
  medium: 0.2,
  hard: 0.3,
};
